import { stringify } from 'csv-stringify/sync'

/**
 * Generates a CSV template for exhibitor import
 * Creates a downloadable CSV file with proper headers matching backend expectations
 */
export const downloadExhibitorTemplate = () => {
  // Template data with headers matching backend's expected format
  // Using the same format as production CSVs (with spaces in column names)
  const templateData = [
    {
      'First Name': 'John',
      'Last Name': 'Doe',
      Email: 'john.doe@example.com',
      'Company Name': 'Example Corp',
      Category: 'Technology',
      'Promo Code': 'EXAMPLE2024',
    },
  ]

  // Generate CSV content using csv-stringify for proper escaping
  const csvContent = stringify(templateData, {
    header: true,
    columns: [
      { key: 'First Name', header: 'First Name' },
      { key: 'Last Name', header: 'Last Name' },
      { key: 'Email', header: 'Email' },
      { key: 'Company Name', header: 'Company Name' },
      { key: 'Category', header: 'Category' },
      { key: 'Promo Code', header: 'Promo Code' },
    ],
  })

  // Create blob and download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')

  if (link.download !== undefined) {
    // Create download link
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', 'exhibitor-import-template.csv')
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Delay URL revocation to ensure download starts in all browsers
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
  }
}
